import { GoogleTagManager } from '@mirai-kids-monte/core/src/components/utils/GoogleTagManager';
import '@mirai-kids-monte/core/src/styles/_reset.scss';
import { type AppProps } from 'next/app';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { PageUrl } from '../src/constants/PageUrl';
import { zenMaruGothic } from '../src/fonts/zenMaruGothic';
// react-datepickerにスタイルを当てるためのcss.
// Next.jsではこのファイルでしかGlobal cssのimportができないため暫定処置としてこうしている
import '../src/styles/app-globals.scss';
import '../src/styles/react-datepicker.css';

// NOTE: _document.tsx のインラインスクリプトも同じパスを参照しています。
// 対象パスを追加・削除するときは必ず両ファイルを同時に更新してください。
const SMALL_FONT_PATH_PREFIXES = [
  PageUrl.TOOL_RECOMMENDATION_ROOT,
  PageUrl.MONTE_CHAT_ROOT,
  PageUrl.DIAGNOSIS_ROOT,
  '/lp/',
] as const;

const normalizePathname = (pathname: string) => (pathname.endsWith('/') ? pathname : `${pathname}/`);

const isSmallFontPath = (pathname: string) => {
  const normalizedPathname = normalizePathname(pathname);

  return SMALL_FONT_PATH_PREFIXES.some((prefix) => normalizedPathname.startsWith(prefix));
};

const useFontScale = () => {
  const { pathname } = useRouter();

  useEffect(() => {
    const isSmallFont = isSmallFontPath(pathname);
    document.documentElement.setAttribute('data-font-scale', isSmallFont ? 'default' : 'large-pc');
  }, [pathname]);
};

const MyApp = ({ Component, pageProps }: AppProps) => {
  useFontScale();

  return (
    <>
      {/* app-globals.scss の body font-family が参照する。next/font は _document で使えないため _app で定義する */}
      {/* eslint-disable-next-line react/no-unknown-property -- styled-jsx の jsx/global 属性 */}
      <style jsx global>{`
        :root {
          --font-zen-maru-gothic: ${zenMaruGothic.style.fontFamily};
        }
      `}</style>
      <GoogleTagManager />
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Component {...pageProps} />
    </>
  );
};

export default MyApp;
